<template>
    <div>
        <v-card elevation="0">
            <v-card-title>
                <v-row align="center">
                    <v-col cols="5">
                        <v-select :items="filterItems" item-text="label" item-value="value" v-model="shownotapproved" @change="showPostings()" outlined dense hide-details label="Filter"></v-select>
                    </v-col>
                    <v-col cols="7" class="d-flex justify-end" v-if="permissions.postingwrite">
                        <v-btn color="#1D4E89" @click="dialogadd = true" class="white--text">
                            <v-icon color="white">mdi-plus-thick</v-icon>
                            Create new Posting
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :search="search"
                    :custom-filter="customSearchFilter"
                    sort-by="createdTimestamp"
                    sort-desc="true"
                    class="elevation-0 text-body-2"
                    color="#D4F1F4"
                    :loading="tableloading"
                    loading-text="Calling Postings..."
                >
                    <template v-slot:top>
                        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="Search" single-line class="ma-2" dense outlined persistent-hint hint="Search will only search for 'Discipline' (NOT Title) or/and 'Catalog(s)' fields">
                            <template v-slot:append-outer>
                                <v-dialog width="400" v-model="dialogLegend">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon color="#145DA0" v-bind="attrs" v-on="on" small><v-icon>mdi-information</v-icon></v-btn>
                                    </template>
                                    <v-card elevation="0">
                                        <v-toolbar color="primary" dark elevation="0" dense>
                                            Color Legends
                                            <v-spacer></v-spacer>
                                            <v-btn icon dark @click="dialogLegend = false" small>
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </v-toolbar>
                                        <v-card-text>
                                            <br />
                                            <v-icon left color="#EF7C8E" small>mdi-circle</v-icon>&nbsp;Posting start date past but not approved fully<br />
                                            <v-icon left color="#18A558" small>mdi-circle</v-icon>&nbsp;Posting approved fully<br />
                                            <v-icon left color="#2E8BC0" small>mdi-circle</v-icon>&nbsp;Posting start date coming and not approved fully<br />
                                            <v-icon left color="#FF9636" small>mdi-circle</v-icon>&nbsp;Posting closed for applicants<br />
                                        </v-card-text>
                                    </v-card>
                                </v-dialog>
                            </template>
                        </v-text-field>
                    </template>
                    <template v-slot:item.approvedStatus="{ item }">
                        <v-row style="margin: auto;" no-gutters>
                            <v-checkbox v-model="item.approve1" readonly :true-value="1" dense hide-details></v-checkbox>
                            <v-checkbox v-model="item.approve2" readonly :true-value="1" dense hide-details></v-checkbox>
                        </v-row>
                    </template>
                    <template v-slot:item.startDate="{ item }">
                        <v-chip :color="getColor(item.startDate, item.approved)" text-color="white" small>
                            {{ item.startDate }}
                        </v-chip>
                    </template>
                    <template v-slot:item.endDate="{ item }">
                        <v-chip color="#FF9636" text-color="white" small v-if="calEndDate(item.endDate)">
                            {{ item.endDate }}
                        </v-chip>
                        <v-chip outlined small v-else>
                            {{ item.endDate }}
                        </v-chip>
                    </template>
                    <template v-slot:item.lastupdate="{ item }">
                        {{ item.person }}, {{ item.datetime }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-btn
                            small icon class="mr-2" color="#1D4E89"
                            @click="editItem(item)"
                            v-if="permissions.postingwrite && !(item.approve1 == 1 && item.approve2 == 1)"
                        >
                            <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <v-btn
                            small icon class="mr-2" color="#1D4E89"
                            @click="editLiveItem(item)"
                            v-if="permissions.postingliveedit && (item.approve1 == 1 && item.approve2 == 1) && item.status == 'active' && !calEndDate(item.endDate)"
                        >
                            <v-icon>mdi-clock-edit-outline</v-icon>
                        </v-btn>
                        <v-btn
                            small icon class="mr-2" color="#C197D2"
                            @click="viewItem(item)"
                        >
                            <v-icon>mdi-eye-check-outline</v-icon>
                        </v-btn>
                        
                    </template>
                    <template v-slot:item.manager="{ item }">
                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon color="#DF362D"
                                v-bind="attrs"
                                v-on="on"
                                v-if="item.status == 'stopped'"
                            >
                                <v-icon>mdi-alert-octagon-outline</v-icon>
                            </v-btn>
                            </template>
                            <span>Stopped Posting</span>
                        </v-tooltip>
                        <v-btn
                            icon color="#FF8300"
                            @click="openStopPostingDialog(item)"
                            v-if="item.status == 'active' && item.approve2 == 1 && permissions.postingstop && !calEndDate(item.endDate)"
                        >
                            <v-icon>mdi-stop-circle-outline</v-icon>
                        </v-btn>
                        <v-btn
                            icon color="#F8D210"
                            @click="openDeletePostingDialog(item)"
                            v-if="item.status == 'active' && item.approve2 == 0 && permissions.postingdelete"
                        >
                            <v-icon>mdi-delete-circle-outline</v-icon>
                        </v-btn>
                        <v-btn
                            icon color="#333652"
                            v-if="item.status == 'active' && calEndDate(item.endDate) && item.hasOwnProperty('approvals') && item.approvals.length == 2 && permissions.offerlettergenerate"
                            @click="openOfferletterDialog(item)"
                        >
                            <v-icon>mdi-account-star-outline</v-icon>
                        </v-btn>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs" v-on="on"
                                    icon :color="item.hasOwnProperty('filled') && item.filled.length > 0 ? '#2E7D32': '#D7AE28'"
                                    v-if="item.status == 'active' && calEndDate(item.endDate) && permissions.postingfill && item.hasOwnProperty('offerLetterCandidates') && item.offerLetterCandidates.length > 0"
                                    @click="openPostingFilledDialog(item)"
                                >
                                    <v-icon v-if="item.hasOwnProperty('filled') && item.filled.length > 0">mdi-clipboard-check-outline</v-icon>
                                    <v-icon v-else>mdi-clipboard-minus-outline</v-icon>
                                </v-btn>
                            </template>
                            <span v-if="item.hasOwnProperty('filled') && item.filled.length > 0">Position Filled</span>
                            <span v-else>Position Not Filled</span>
                        </v-tooltip>
                        <v-btn icon :color="item.hasOwnProperty('postingcomment') && item.postingcomment.comment.length > 0 ? '#E7625F' : '#A49393'" v-if="permissions.postingfill" @click="openCommentBox(item)">
                            <v-icon v-if="item.hasOwnProperty('postingcomment') && item.postingcomment.comment.length > 0">mdi-comment-alert</v-icon>
                            <v-icon v-else>mdi-comment-processing</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
            <!--Dialogs-->
            <v-dialog v-model="dialogadd" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card height="100%">
                    <v-toolbar dark color="#5885AF">
                        <v-toolbar-title>Add New Posting</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="closeAddDialog()"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <AddPosting v-on:closeEvent="closeAddDialog" v-if="dialogadd" />
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogview" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
                <v-card elevation="0">
                    <v-toolbar dark color="#5885AF" height="80px" elevation="0">
                        <v-toolbar-title>View Postings Detail for {{ selectedItem["subject-resolved"] }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="closeViewDialog()"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text style="height: 100%; width: 100%;">
                        <ViewPosting v-if="dialogview" :item="selectedItem" v-on:closeEvent="closeViewDialog" />
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogedit" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable v-if="permissions.postingwrite">
                <v-card elevation="0">
                    <v-toolbar dark color="#5885AF" height="80px" elevation="0">
                        <v-toolbar-title>Edit Posting Details for {{ selectedItem["subject-resolved"] }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="closeEditDialog()"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text style="height: 100%; width: 100%;">
                        <EditPosting v-if="dialogedit" :item="selectedItem" />
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogliveedit" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable v-if="permissions.postingliveedit">
                <v-card elevation="0">
                    <v-toolbar dark color="#5885AF" height="80px" elevation="0">
                        <v-toolbar-title>Edit Posting Details for {{ selectedItem["subject-resolved"] }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="closeLiveEditDialog()"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text style="height: 100%; width: 100%;">
                        <EditLivePosting v-if="dialogliveedit" :item="selectedLiveEditItem" />
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogstop" width="600" v-if="permissions.postingstop" persistent>
                <v-card>
                    <v-toolbar dark color="#FFA384" elevation="0">
                        <v-toolbar-title>Stop Posting</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="closeStopDialog"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar><br />
                    <v-card-text>
                        This posting for <b>{{ selectedItem["subject-resolved"]+" ("+selectedItem["type"]+")" }}</b> will be no longer visible for applicants.<br />
                        Please indicate the reason below:<br /><br />
                        <v-textarea v-model="stopreason" height="100" @keydown="validateStop()" outlined></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="stopbtndisable" color="#FFA384" @click="stopPosting()" :loading="stoploading">Stop Posting</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogdelete" width="600" v-if="permissions.postingdelete" persistent>
                <v-card>
                    <v-toolbar dark color="#F51720" elevation="0">
                        <v-toolbar-title>Delete Posting</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="closeDeleteDialog"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar><br />
                    <v-card-text>
                        This posting for <b>{{ selectedDeleteItem["subject-resolved"]+" ("+selectedDeleteItem["type"]+")" }}</b> will be deleted permanently from the database.<br />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#F51720" dark @click="deletePosting()" :loading="deleteloading">Delete Posting</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogofferletter" fullscreen persistent v-if="permissions.offerlettergenerate">
                <v-card>
                    <v-toolbar dark color="#333652" elevation="0">
                        <v-toolbar-title>Generate Offer Letter</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="closeOfferletterDialog"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar><br />
                    <v-card-text>
                        <GenerateOfferLetter v-if="dialogofferletter" :posting="selectedOfferLetterPosting" :permissions="permissions" v-on:reloadEvent="closeOfferletterDialog" />
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogPostingFilled" width="750px" persistent v-if="permissions.postingfill">
                <v-card>
                    <v-toolbar dark color="#00A8A8" elevation="0">
                        <v-toolbar-title>Mark this posting Filled</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="closePostingFilledDialog"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar><br />
                    <v-card-text>
                        <FillPosting :posting="selectedFilledPosting" v-on:reloadEvent="closePostingFilledDialog" v-if="dialogPostingFilled" />
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogCommentBox" width="750px" persistent v-if="permissions.postingfill">
                <v-card v-if="dialogCommentBox">
                    <v-toolbar dark color="#A49393" elevation="0">
                        <v-toolbar-title>Comment on this Posting</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="dialogCommentBox = false;"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar><br />
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" v-if="selectedCommentItem.postingcomment.hasOwnProperty('lastUpdatedTimestamp')">
                                Last Updated on <strong>{{ convertTimestamp(selectedCommentItem.postingcomment.lastUpdatedTimestamp) }}</strong> by <strong>{{ selectedCommentItem.postingcomment.lastUpdatedCommonName }}</strong>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea outlined v-model="selectedCommentItem.postingcomment.comment"></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#A49393" outlined :loading="savecommentloading" @click="saveComment">Save Comment</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import ViewPosting from "./ViewPosting.vue"
import AddPosting from "./AddPosting.vue"
import EditPosting from "./EditPosting.vue"
import EditLivePosting from "./LiveEditPosting.vue"

import GenerateOfferLetter from "./GenerateOfferLetter.vue"
import FillPosting from "./FillPosting.vue"

import auth from '@/js/auth'

export default {
    components: {
        ViewPosting,
        AddPosting,
        EditPosting,
        EditLivePosting,
        GenerateOfferLetter,
        FillPosting
    },
    data () {
      return {
        permissions: {},
        host: location.hostname.toString(),
        tableloading: false,
        search: '',
        filterItems: [
            {label: "All", value: "all"},
            {label: "Active", value: "active"},
            {label: "Expired (excluding stopped postings)", value: "expired"},
            {label: "No Approvals", value: "napp"},
            {label: "One Approval", value: "oneapp"},
            {label: "Stopped", value: "stopped"}
        ],
        headers: [
            {text: "Approved", value: "approvedStatus"},
            {text: "Title", value: "title"},
            {text: "Discipline", value: "discipline"},
            {text: "Type", value: "type"},
            {text: "Catalog(s)", value: "coursesText"},
            {text: "Section(s)", value: "sectionsText"},
            {text: "Posting Start", value: "startDate"},
            {text: "Posting End", value: "endDate"},
            {text: "Last Updated", value: "lastupdate"},
            { text: 'Actions', value: 'actions', sortable: false },
            { text: 'Manager', value: 'manager', sortable: false }
        ],
        items: [],
        dialogLegend:false,
        dialogadd: false,
        dialogview: false,
        dialogedit: false,
        dialogliveedit: false,
        dialogstop: false,
        dialogdelete: false,
        stopbtndisable: true,
        stopreason: "",
        stoploading: false,
        deleteloading: false,
        selectedItem: {},
        selectedLiveEditItem: {},
        selectedDeleteItem: {},
        shownotapproved: "all",
        snackbar: false,
        snackbarcolor: "",
        text: "",
        timeout: 3500,
        dialogofferletter: false,
        selectedOfferLetterPosting: {},
        dialogPostingFilled: false,
        selectedFilledPosting: {},
        selectedCommentItem: {},
        dialogCommentBox: false,
        savecommentloading: false
      }
    },
    methods: {
        getPermissions(){
            const that = this;
            let permission = auth.get_permissions();

            if(permission.hasOwnProperty("postingwrite")){
                if(permission.postingwrite == 1){
                    that.permissions["postingwrite"] = true;
                }else {
                    that.permissions["postingwrite"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["postingwrite"] = true;
            }else {
                that.permissions["postingwrite"] = false;
            }

            if(permission.hasOwnProperty("postingstop")){
                if(permission.postingstop == 1){
                    that.permissions["postingstop"] = true;
                }else {
                    that.permissions["postingstop"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["postingstop"] = true;
            }else {
                that.permissions["postingstop"] = false;
            }

            if(permission.hasOwnProperty("postingdelete")){
                if(permission.postingdelete == 1){
                    that.permissions["postingdelete"] = true;
                }else {
                    that.permissions["postingdelete"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["postingdelete"] = true;
            }else {
                that.permissions["postingdelete"] = false;
            }

            //live edit permission
            if(permission.hasOwnProperty("postingliveedit")){
                if(permission.postingliveedit == 1){
                    that.permissions["postingliveedit"] = true;
                }else {
                    that.permissions["postingliveedit"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["postingliveedit"] = true;
            }else {
                that.permissions["postingliveedit"] = false;
            }

            //Offer Letter Permission
            if(permission.hasOwnProperty("offerlettergenerate")){
                if(permission.offerlettergenerate == 1){
                    that.permissions["offerlettergenerate"] = true;
                }else {
                    that.permissions["offerlettergenerate"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["offerlettergenerate"] = true;
            }else {
                that.permissions["offerlettergenerate"] = false;
            }

            //Posting Filled Permission
            if(permission.hasOwnProperty("postingfill")){
                if(permission.postingfill == 1){
                    that.permissions["postingfill"] = true;
                }else {
                    that.permissions["postingfill"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["postingfill"] = true;
            }else {
                that.permissions["postingfill"] = false;
            }

            //HR Flag permission
            if(permission.hasOwnProperty("setHRflag")){
                if(permission.setHRflag == 1){
                    that.permissions["setHRflag"] = true;
                }else {
                    that.permissions["setHRflag"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["setHRflag"] = true;
            }else {
                that.permissions["setHRflag"] = false;
            }
        },
        customSearchFilter(value, search, item){
            if(search == "" || search == null){
                return true
            }else {
                let loweredsearch = search.toLowerCase();
                
                let spacestripedout = loweredsearch.replace(" ", "")
                let combinedField = item.discipline.toLowerCase()+item.coursesText.toLowerCase();
                
                return item.discipline.toLowerCase().includes(loweredsearch) || item.coursesText.toLowerCase().includes(loweredsearch) || combinedField.includes(spacestripedout)

                // if(search.includes(",")){
                //     let discipline = search.split(",")[0].toLowerCase();
                //     let coursenumber = search.split(",")[1].toLowerCase();

                //     return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(discipline)) && Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(coursenumber));
                // }else {
                //     return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search.toLowerCase()))
                // }
            }
        },
        getColor(startdate, approved) {
            let today = Date.now();
            let start = Date.parse(startdate);

            if(start<=today && approved == "no"){
                return "#EF7C8E"
            }else if(approved == "yes"){
                return "#18A558"
            }else if(start>today && approved == "no"){
                return "#2E8BC0"
            }
        },
        calEndDate(date){
            const MSPERDAY = 1000 * 60 * 60 * 24;
            let today = new Date();
            let due = new Date(date);
            let todayutc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
            let dateutc = Date.UTC(due.getFullYear(), due.getMonth(), due.getDate());

            let daysleft = Math.floor((dateutc - todayutc) / MSPERDAY)+1;

            if(daysleft < 0){
                return true
            }else {
                return false
            }
        },
        calStartDate(startdate, approvals) {
            let today = Date.now();
            let start = Date.parse(startdate);

            let approved = "no";

            if(approvals.length < 2){
                approved = "no";
            }else{
                approved = "yes";
            }

            if(start<=today && approved == "yes"){
                return true
            }else {
                return false
            } 
        },
        showPostings(){
            const that = this;
            that.items = [];
            
            if(that.shownotapproved == "napp"){
                that.filterNotApprovedPostings();
            }else if(that.shownotapproved == "all"){
                that.loadTable();
            }else if(that.shownotapproved == "oneapp"){
                that.filterOneApprovedPostings();
            }else if(that.shownotapproved == "stopped"){
                that.filterStoppedPostings();
            }else if(that.shownotapproved == "active"){
                that.filterLivePostings();
            }else if(that.shownotapproved == "expired"){
                that.filterExpiredPostings();
            }
        },
        loadTable(){
            const that = this;
            that.tableloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=adminpostingsget';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.items = resultData.data;

                        that.modifyData();
                        that.tableloading = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        closeAddDialog(){
            const that = this;
            that.dialogadd = false;
            that.showPostings();
        },
        closeViewDialog(){
            const that = this;
            that.dialogview = false;
            that.showPostings();
        },
        closeEditDialog(){
            const that = this;
            that.dialogedit = false;
            that.showPostings();
        },
        closeLiveEditDialog(){
            const that = this;
            that.dialogliveedit = false;
            that.showPostings();
        },
        closeStopDialog(){
            const that = this;
            that.dialogstop = false;
            that.selectedItem = {};
            that.showPostings();
        },
        closeDeleteDialog(){
            const that = this;
            that.dialogdelete = false;
            that.selectedDeleteItem = {};
            that.showPostings();
        },
        filterNotApprovedPostings(){
            const that = this;

            that.tableloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=adminpostingssearch&data={"$and": [{"approvals": {"$exists":false}}, {"status":"active"}]}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.items = resultData.data;

                        that.modifyData();
                        that.tableloading = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        filterOneApprovedPostings(){
            const that = this;

            that.tableloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=adminpostingssearch&data={"$and": [{"approvals": {"$size":1}}, {"status":"active"}]}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.items = resultData.data;

                        that.modifyData();
                        that.tableloading = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        filterStoppedPostings(){
            const that = this;
            that.tableloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=adminpostingssearch&data={"status":"stopped"}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.items = resultData.data;

                        that.modifyData();
                        that.tableloading = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        filterLivePostings(){
            const that = this;
            that.tableloading = true;
            that.items = [];
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=adminpostingssearch&data={"status":"active"}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {

                        resultData.data.forEach(element => {
                            let approvals = [];
                            if(!element.hasOwnProperty("approvals")){
                                approvals = [];
                            }else {
                                approvals = element["approvals"];
                            }
                            
                            if(that.calStartDate(element["startDate"],approvals) == true && that.calEndDate(element["endDate"]) == false){
                                that.items.push(element);
                            }
                        });

                        that.modifyData();
                        that.tableloading = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        filterExpiredPostings(){
            const that = this;
            that.tableloading = true;
            that.items = [];
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=adminpostingssearch&data={"status":"active"}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {

                        resultData.data.forEach(element => {
                            let approvals = [];
                            if(!element.hasOwnProperty("approvals")){
                                approvals = [];
                            }else {
                                approvals = element["approvals"];
                            }
                            
                            if(that.calStartDate(element["startDate"],approvals) == true && that.calEndDate(element["endDate"]) == true){
                                that.items.push(element);
                            }
                        });

                        that.modifyData();
                        that.tableloading = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        modifyData(){
            const that = this;

            that.items.forEach(element => {
                //Dates
                var date = new Date();
                var updated = "";
                if(element.hasOwnProperty("updatedTimestamp")){
                    date = new Date(parseInt(element["updatedTimestamp"]));
                    updated = element["updatedByCommonName"];
                }else {
                    date = new Date(parseInt(element["createdTimestamp"]));
                    updated = element["createdByCommonName"];
                }

                element["datetime"] = date.toISOString().split("T")[0];
                element["person"] = updated;
                
                //Courses
                var courselist = "";
                var sectionsText = "";
                element["courses"].forEach(e => {
                    if(e["ssrcomponent"] == "LEC"){
                        courselist += e["catalognbr"]+", ";
                        sectionsText += e["classsection"]+", ";
                    }
                });

                element["coursesText"] = courselist.slice(0,-2);
                element["sectionsText"] = sectionsText.slice(0,-2);
                element["subject-resolved"] = element["courses"][0]["subject-resolved"];
                
                if(!element.hasOwnProperty("approvals")){
                    element["approve1"] = 0;
                    element["approve2"] = 0;
                    element["approved"] = "no";
                }else if(element["approvals"].length == 1){
                    element["approve1"] = 1;
                    element["approve2"] = 0;
                    element["approved"] = "no";
                }else if(element["approvals"].length == 2){
                    element["approve1"] = 1;
                    element["approve2"] = 1;
                    element["approved"] = "yes";
                }
                
                
            });
        },
        viewItem(item){
            const that = this;
            that.dialogview = true;
            that.selectedItem = item;
        },
        editItem(item){
            const that = this;
            that.selectedItem = item;
            that.dialogedit = true;
        },
        editLiveItem(item){
            const that = this;
            that.selectedLiveEditItem = item;
            that.dialogliveedit = true;
        },
        openStopPostingDialog(item){
            const that = this;

            that.selectedItem = item;
            that.dialogstop = true;
        },
        openDeletePostingDialog(item){
            const that = this;

            that.selectedDeleteItem = item;
            that.dialogdelete = true;
        },
        validateStop(){
            const that = this;

            if(that.stopreason.length > 0){
                that.stopbtndisable = false;
            }else {
                that.stopbtndisable = true;
            }
        },
        stopPosting(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            that.stoploading = true;
            
            let stop = {
                id: that.selectedItem.id,
                stopreason: that.stopreason
            };

            const formData = new FormData();

            formData.append("mode", "postingStop");
            formData.append("data", JSON.stringify(stop));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                        that.stoploading = false;
                    }else {
                        that.setSnackbar("Posting Stopped", "#388E3C"); //green
                        that.showPostings();
                        that.stoploading = false;
                        that.dialogstop = false;
                        that.selectedItem = {};
                        that.stopreason = "";
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.stoploading = false;
                })
            //End of API calling
        },
        deletePosting(){
            const that = this;
            that.deleteloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=postingdelete&data={"id":"'+that.selectedDeleteItem.id+'"}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Success: "+resultData.message, "green");
                        that.showPostings();
                        that.dialogdelete = false;
                        that.selectedDeleteItem = {};
                    }

                    that.deleteloading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.deleteloading = false;
                })
            //End of API calling
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        },
        //2024 Mar-May update: Offer Letter Generation & Posting Filled functions
        openOfferletterDialog(item){
            const that = this;

            that.selectedOfferLetterPosting = item;
            that.dialogofferletter = true;
        },
        closeOfferletterDialog(){
            const that = this;

            that.dialogofferletter = false;
            that.selectedOfferLetterPosting = {};
            that.showPostings();
        },
        openPostingFilledDialog(item){
            const that = this;

            that.selectedFilledPosting = item;
            that.dialogPostingFilled = true;
        },
        closePostingFilledDialog(){
            const that = this;
            that.dialogPostingFilled = false;
            that.selectedFilledPosting = {};
            that.showPostings();
        },
        openCommentBox(item){
            const that = this;

            that.selectedCommentItem = item;

            if(!that.selectedCommentItem.hasOwnProperty("postingcomment")){
                that.selectedCommentItem["postingcomment"] = {
                    "comment": ""
                }
            }
            
            that.dialogCommentBox = true;
        },
        saveComment(){
            const that = this;

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            that.savecommentloading = true;
            
            let comment = {
                id: that.selectedCommentItem.id,
                comment: that.selectedCommentItem.postingcomment.comment
            };

            const formData = new FormData();

            formData.append("mode", "postingComment");
            formData.append("data", JSON.stringify(comment));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                        that.savecommentloading = false;
                    }else {
                        that.setSnackbar("Comment Saved", "#388E3C"); //green
                        that.savecommentloading = false;
                        that.dialogCommentBox = false;
                        that.showPostings();
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.savecommentloading = false;
                })

        },
        convertTimestamp(timestamp){
            let date = new Date(parseInt(timestamp));

            return date.toLocaleString();
        }
    },
    created(){
        const that = this;
        that.getPermissions();
        that.showPostings();
    }
  }
</script>